<div class="allele-promoter" *ngFor="let allelePromoter of annotation.allele_promoters">
  <span *ngIf="isMultiLocusGenotype">{{allelePromoter.allele_display_name}}</span>
  <span *ngIf="(long || isMultiLocusGenotype)">promoter:</span>
  <span *ngIf="allelePromoter.promoter">
   {{allelePromoter.promoter}}
  </span>
</div>
